export default {
  SET_STATE: 'adminSettings/SET_STATE',
  POST_SETTINGS: 'adminSettings/POST_SETTINGS',
  FETCH_SINGLE: 'adminSettings/FETCH_SINGLE',
}
